export default __webpack_public_path__ + "static/media/PIE-Prueba.f0b72fcb.mp4";